import { Box, Flex } from '@chakra-ui/react';

import { BrowserRouter as Router, Route, Routes, useLocation,Navigate, useNavigate } from "react-router-dom";
import NavBarTech from '../NavBarTech';
import LandingPageTech from '../LandingPageTech';
import TermsAndConditionsTech from '../TermsAndConditionsTech';
import AboutTechPage from '../AboutTechPage';
import { CaseStudyList } from '../CaseStudyList';
import { CaseStudyDetailsPage } from '../CaseStudyDetailsPage';



const TechnologyRouter = () => {

    return (
        <Box >
        <NavBarTech />       
           
          {/* Main content area with flexible width */}
          <Box overflowY="auto">
            <Routes>

                <Route path="/" element={<Navigate to="landing-page" />} />
                <Route path="landing-page" element={<LandingPageTech />} />
                <Route path="termsandconditions" element={<TermsAndConditionsTech />} />
                <Route path="about-tech" element={<AboutTechPage />} />
                <Route path="case-studies" element={<CaseStudyList />} />
                <Route path="case-study-details/:case_study_id" element={<CaseStudyDetailsPage />} />
            </Routes>
          </Box>
          
      </Box>
    );
  };

export default TechnologyRouter;
